import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {MaterialModule} from '../../app/material.module';
import { CategoryEdit } from '../role/admin/components/categories/modals/create/component';
import {CategoriesList} from './components/list/component';
import {CategoryApiService} from './services/category-api-service';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [CategoriesList, CategoryEdit],
  providers: [CategoryApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CategoriesList],
})
export class CategoryModule {}
